import { CHANGE_TITLE } from "../constants/ActionTypes";

const initialState = {
  pageTitle: "Easy Salon Appointments | Vibo Vibo",
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANGE_TITLE:
      return { ...state, pageTitle: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/ChangeTitle.js